/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Plan_Change_Unavailable_PrepaidInputs */

const en_plan_change_unavailable_prepaid = /** @type {(inputs: Plan_Change_Unavailable_PrepaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plan changes open after ${i?.date}, when your prepaid time ends.`)
};

const es_plan_change_unavailable_prepaid = /** @type {(inputs: Plan_Change_Unavailable_PrepaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podrás cambiar de plan después del ${i?.date}, cuando termine el tiempo que ya pagaste.`)
};

/**
* | output |
* | --- |
* | "Plan changes open after {date}, when your prepaid time ends." |
*
* @param {Plan_Change_Unavailable_PrepaidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_unavailable_prepaid = /** @type {((inputs: Plan_Change_Unavailable_PrepaidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Unavailable_PrepaidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_unavailable_prepaid(inputs)
	return en_plan_change_unavailable_prepaid(inputs)
});